import { render, staticRenderFns } from "./NaVerticalslot.vue?vue&type=template&id=0afaae06&scoped=true"
import script from "./NaVerticalslot.vue?vue&type=script&lang=js"
export * from "./NaVerticalslot.vue?vue&type=script&lang=js"
import style0 from "./NaVerticalslot.vue?vue&type=style&index=0&id=0afaae06&prod&lang=less"
import style1 from "./NaVerticalslot.vue?vue&type=style&index=1&id=0afaae06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaae06",
  null
  
)

export default component.exports